module.exports = __webpack_public_path__ + "img/animal_festa_stamp.b4fd87db.png";